import Vue from "vue";
import VueRouter from 'vue-router';
import Home from "../views/home/Home.vue";
import ControleAcesso from "../views/controle-acesso/ControleAcesso.vue";
import GerenciarExercicios from "../views/exercicios/GerenciarExercicios.vue";
import GerenciarFontes from "../views/fontes/GerenciarFontes.vue";
import GerenciarAcoes from "../views/acoes/GerenciarAcoes.vue";
import GerenciarSecoes from "../views/secoes/GerenciarSecoes.vue";
import GerenciarElementosItens from "../views/elementos-itens/GerenciarElementosItens.vue";
import GerenciarIpgs from "../views/ipg/GerenciarIpgs.vue";
import GerenciarUnidadesOrcamentarias from "../views/unidades-orcamentarias/GerenciarUnidadesOrcamentaria.vue";
import GerenciarUnidadesExecutoras from "../views/unidades-executoras/GerenciarUnidadesExecutoras.vue";
import GerenciarIpus from "../views/ipu/GerenciarIpus.vue";
import GerenciarGrupos from "../views/grupo/GerenciarGrupos.vue";
import GerenciarElementos from "../views/elemento/GerenciarElementos.vue";
import GerenciarProgramas from "../views/programa/GerenciarProgramas.vue";
import GerenciamentoTabelasBasicas from "../views/tabelas-basicas/GerenciamentoTabelasBasicas.vue";
import GerenciamentoTabelasCargas from "../views/tabelas-cargas/GerenciamentoTabelasCargas.vue";
import GerenciarPpags from "../views/ppag/GerenciarPpags.vue";
import ImportarPpag from "../views/ppag/importar/ImportarPpag.vue";
import ImportarDotacoes from "../views/dotacoes/importar/ImportarDotacoes.vue";

import ImportarUnidadesPrimarias from "../views/unidades-primarias/importar/ImportarUnidadesPrimarias.vue";
import GerenciarUnidadesPrimarias from "../views/unidades-primarias/GerenciarUnidadesPrimarias.vue";
import EditarUnidadePrimaria from "../views/unidades-primarias/editar/EditarUnidadePrimaria.vue";

import GerenciarDotacoes from "../views/dotacoes/GerenciarDotacoes.vue";
import GerenciarPlanos from "../views/planos/gerenciamento/GerenciarPlanos.vue";
import CriarAcao from "../views/acoes/criar/CriarAcao.vue";
import EditarAcao from "../views/acoes/editar/EditarAcao.vue";
import CriarElemento from "../views/elemento/criar/CriarElemento.vue";
import CriarElementoItem from "../views/elementos-itens/criar/CriarElementoItem.vue";
import CriarExercicio from "../views/exercicios/criar/CriarExercicio.vue";
import CriarFonte from "../views/fontes/criar/CriarFonte.vue";
import CriarIpg from "../views/ipg/criar/CriarIpg.vue";
import CriarIpu from "../views/ipu/criar/CriarIpu.vue";
import CriarGrupo from "../views/grupo/criar/CriarGrupo.vue";
import CriarPpag from "../views/ppag/criar/CriarPpag.vue";
import CriarPrograma from "../views/programa/criar/CriarPrograma.vue";
import CriarSecao from "../views/secoes/criar/CriarSecao.vue";
import CriarUnidadeExecutora from "../views/unidades-executoras/criar/CriarUnidadeExecutora.vue";
import CriarUnidadeOrcamentaria from "../views/unidades-orcamentarias/criar/CriarUnidadeOrcamentaria.vue";

import EditarElemento from "../views/elemento/editar/EditarElemento.vue"
import EditarElementoItem from "../views/elementos-itens/editar/EditarElementoItem.vue"
import EditarExercicio from "../views/exercicios/editar/EditarExercicio.vue";
import EditarFonte from "../views/fontes/editar/EditarFonte.vue";
import EditarIpg from "../views/ipg/editar/EditarIpg.vue";
import EditarIpu from "../views/ipu/editar/EditarIpu.vue";
import EditarGrupo from "../views/grupo/editar/EditarGrupo.vue";
import EditarPpag from "../views/ppag/editar/EditarPpag.vue";
import EditarPrograma from "../views/programa/editar/EditarPrograma.vue";
import EditarSecao from "../views/secoes/editar/EditarSecao.vue";
import EditarUnidadeExecutora from "../views/unidades-executoras/editar/EditarUnidadeExecutora.vue";
import EditarUnidadeOrcamentaria from "../views/unidades-orcamentarias/editar/EditarUnidadeOrcamentaria.vue";

import Index from "../views/dotacoes/visualizar/Index.vue";
import IndexAprovacao from "../views/aprovacoes/visualizar/IndexAprovacao.vue";
import IndexRepasse from "../views/repasses/visualizar/IndexRepasse.vue";
import IndexDescentralizacao from "../views/descentralizacoes/visualizar/IndexDescentralizacao.vue";

import ImportarAprovacoes from "../views/aprovacoes/importar/ImportarAprovacoes.vue";
import GerenciarAprovacoes from "../views/aprovacoes/GerenciarAprovacoes.vue";
import ImportarRepasses from "../views/repasses/importar/ImportarRepasses.vue";
import GerenciarRepasses from "../views/repasses/GerenciarRepasses.vue";
import ImportarDescentralizacoes from "../views/descentralizacoes/importar/ImportarDescentralizacoes.vue";
import GerenciarDescentralizacoes from "../views/descentralizacoes/GerenciarDescentralizacoes.vue";

import IndexConfiguracao from "../views/logs/configuracao/IndexConfiguracao.vue";
import GerenciarLogs from "../views/logs/GerenciarLogs.vue"
import VisualizarLog from "../views/logs/visualizar/VisualizarLog.vue"

import ImportarProcessosCompra from "../views/processos-compra/importar/ImportarProcessosCompra.vue"
import ImportarProcessosEmpenho from "../views/processos-compra/empenhos/importar/ImportarProcessosEmpenho.vue"
import GerenciarProcessosEmpenho from "../views/processos-compra/empenhos/GerenciarProcessosEmpenho.vue"
import VisualizarEmpenho from "../views/processos-compra/empenhos/visualizar/VisualizarEmpenho.vue"

import ImportarEmpenhoSIAF from "../views/processos-compra/empenhos/siaf/importar/ImportarEmpenhoSIAF.vue"
import GerenciarEmpenhoSIAF from "../views/processos-compra/empenhos/siaf/GerenciarEmpenhoSIAF.vue"
import VisualizarEmpenhoSIAF from "../views/processos-compra/empenhos/siaf/visualizar/VisualizarEmpenhoSIAF.vue"
import ImportarTransacoesEmpenhoSIAF from "../views/processos-compra/empenhos/siaf/transacoes/importacoes/ImportarTransacoesEmpenhoSIAF.vue"
import GerenciarTransacoesEmpenhoSIAF from "../views/processos-compra/empenhos/siaf/transacoes/GerenciarTransacoesEmpenhoSIAF.vue"
import ImportarRestosPagarSIAF from "../views/processos-compra/restos-pagar-siaf/importar/ImportarRestosPagarSIAF.vue"

import GerenciarCompras from "../views/processos-compra/GerenciarCompras.vue"
import IndexCompra from "../views/processos-compra/visualizar/IndexCompra.vue";

import Montar from "../views/planos/Montar.vue"
import GerenciarEmendasEstaduais from "../views/emendas-estaduais/GerenciarEmendasEstaduais.vue"
import GerenciarEmendasFederais from "../views/emendas-federais/GerenciarEmendasFederais.vue"
import GerenciarConveniosFederais from "../views/convenios-federais/GerenciarConveniosFederais.vue"
import GerenciarElementosPrimariosGenericos from "../views/elementos-primarios-genericos/GerenciarElementosPrimariosGenericos.vue"
import GerenciarElementosPrimariosConsolidados from "../views/elementos-primarios-consolidados/GerenciarElementosPrimariosConsolidados.vue"
import VisualizarElementoPrimarioConsolidado from "../views/elementos-primarios-consolidados/visualizar/VisualizarElementoPrimarioConsolidado.vue"

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/controle-acesso",
    name: "ControleAcesso",
    component: ControleAcesso,
  },
  {
    path: "/gerenciar-acoes",
    name: "GerenciarAcoes",
    component: GerenciarAcoes,
  },
  {
    path: "/acoes/criar",
    name: "CriarAcao",
    component: CriarAcao,
  },
  {
    path: "/gerenciar-elementos",
    name: "GerenciarElementos",
    component: GerenciarElementos,
  },
  {
    path: "/gerenciar-planos-aquisicao",
    name: "GerenciarPlanos",
    component: GerenciarPlanos,
  },
  {
    path: "/elementos/criar",
    name: "CriarElemento",
    component: CriarElemento,
  },
  {
    path: "/gerenciar-processos-compras",
    name: "GerenciarCompras",
    component: GerenciarCompras,
  },
  {
    path: "/importar-empenhos",
    name: "ImportarProcessosEmpenho",
    component: ImportarProcessosEmpenho,
  },
  {
    path: "/importar-empenhos-siaf",
    name: "ImportarEmpenhoSIAF",
    component: ImportarEmpenhoSIAF,
  },
  {
    path: "/importar-transacoes-empenho-siaf",
    name: "ImportarTransacoesEmpenhoSIAF",
    component: ImportarTransacoesEmpenhoSIAF,
  },
  {
    path: "/gerenciar-transacoes-empenho-siaf",
    name: "GerenciarTransacoesEmpenhoSIAF",
    component: GerenciarTransacoesEmpenhoSIAF,
  },
  {
    path: "/importar-restos-pagar-siaf",
    name: "ImportarRestosPagarSIAF",
    component: ImportarRestosPagarSIAF,
  },
  {
    path: "/gerenciar-empenhos",
    name: "GerenciarProcessosEmpenho",
    component: GerenciarProcessosEmpenho,
  },
  {
    path: "/empenhos/visualizar/:id",
    name: "VisualizarEmpenho",
    component: VisualizarEmpenho,
  },
  {
    path: "/gerenciar-empenhos-siaf",
    name: "GerenciarEmpenhoSIAF",
    component: GerenciarEmpenhoSIAF,
  },
  {
    path: "/empenhos-siaf/visualizar/:id",
    name: "VisualizarEmpenhoSIAF",
    component: VisualizarEmpenhoSIAF,
  },
  {
    path: "/gerenciar-elementos-itens",
    name: "GerenciarElementosItens",
    component: GerenciarElementosItens,
  },
  {
    path: "/elementos-itens/criar",
    name: "CriarElementoItem",
    component: CriarElementoItem,
  },
  {
    path: "/gerenciar-exercicios",
    name: "GerenciarExercicios",
    component: GerenciarExercicios,
  },
  {
    path: "/exercicios/criar",
    name: "CriarExercicio",
    component: CriarExercicio,
  },
  {
    path: "/gerenciar-fontes",
    name: "GerenciarFontes",
    component: GerenciarFontes,
  },
  {
    path: "/fontes/criar",
    name: "CriarFonte",
    component: CriarFonte,
  },
  {
    path: "/gerenciar-secoes",
    name: "GerenciarSecoes",
    component: GerenciarSecoes,
  },
  {
    path: "/secoes/criar",
    name: "CriarSecao",
    component: CriarSecao,
  },
  {
    path: "/gerenciar-ipgs",
    name: "GerenciarIpgs",
    component: GerenciarIpgs,
  },
  {
    path: "/ipgs/criar",
    name: "CriarIpg",
    component: CriarIpg,
  },
  {
    path: "/gerenciar-ipus",
    name: "GerenciarIpus",
    component: GerenciarIpus,
  },
  {
    path: "/ipus/criar",
    name: "CriarIpu",
    component: CriarIpu,
  },
  {
    path: "/gerenciar-programas",
    name: "GerenciarProgramas",
    component: GerenciarProgramas,
  },
  {
    path: "/programas/criar",
    name: "CriarPrograma",
    component: CriarPrograma,
  },
  {
    path: "/gerenciar-grupos",
    name: "GerenciarGrupos",
    component: GerenciarGrupos,
  },
  {
    path: "/grupos/criar",
    name: "CriarGrupo",
    component: CriarGrupo,
  },
  {
    path: "/gerenciar-unidades-executoras",
    name: "GerenciarUnidadesExecutoras",
    component: GerenciarUnidadesExecutoras,
  },
  {
    path: "/unidades-executoras/criar",
    name: "CriarUnidadeExecutora",
    component: CriarUnidadeExecutora,
  },
  {
    path: "/gerenciar-unidades-orcamentarias",
    name: "GerenciarUnidadesOrcamentarias",
    component: GerenciarUnidadesOrcamentarias,
  },
  {
    path: "/unidades-orcamentarias/criar",
    name: "CriarUnidadeOrcamentaria",
    component: CriarUnidadeOrcamentaria,
  },
  {
    path: "/gerenciar-tabelas-basicas",
    name: "GerenciamentoTabelasBasicas",
    component: GerenciamentoTabelasBasicas,
  },
  {
    path: "/gerenciar-tabelas-cargas",
    name: "GerenciamentoTabelasCargas",
    component: GerenciamentoTabelasCargas,
  },
  {
    path: "/gerenciar-ppag",
    name: "GerenciarPpags",
    component: GerenciarPpags,
  },
  {
    path: "/ppags/criar",
    name: "CriarPpag",
    component: CriarPpag,
  },
  {
    path: "/importar-elementos-primarios",
    name: "ImportarElementosPrimarios",
    component: ImportarPpag,
  },
  {
    path: "/processos-compras/visualizar/:id",
    name: "IndexCompra",
    component: IndexCompra,
  },
  {
    path: "/aprovacoes/visualizar/:id",
    name: "IndexAprovacao",
    component: IndexAprovacao,
  },
  {
    path: "/importar-aprovacoes-orcamentarias",
    name: "ImportarAprovacoes",
    component: ImportarAprovacoes,
  },
  {
    path: "/descentralizacoes/visualizar/:id",
    name: "IndexDescentralizacao",
    component: IndexDescentralizacao,
  },
  {
    path: "/importar-descentralizacoes-orcamentarias",
    name: "ImportarDescentralizacoes",
    component: ImportarDescentralizacoes,
  },
  {
    path: "/gerenciar-aprovacoes-orcamentarias",
    name: "GerenciarAprovacoes",
    component: GerenciarAprovacoes,
  },
  {
    path: "/importar-repasses-orcamentarios",
    name: "ImportarRepasses",
    component: ImportarRepasses,
  },
  {
    path: "/gerenciar-repasses-orcamentarios",
    name: "GerenciarRepasses",
    component: GerenciarRepasses,
  },
  {
    path: "/gerenciar-descentralizacoes-orcamentarias",
    name: "GerenciarDescentralizacoes",
    component: GerenciarDescentralizacoes,
  },
  {
    path: "/importar-dotacoes-orcamentarias",
    name: "ImportarDotacoes",
    component: ImportarDotacoes,
  },
  {
    path: "/gerenciar-dotacoes-orcamentarias",
    name: "GerenciarDotacoes",
    component: GerenciarDotacoes,
  },
  {
    path: "/acoes/editar/:id",
    name: "EditarAcao",
    component: EditarAcao,
  },
  {
    path: "/elemento/editar/:id",
    name: "EditarElemento",
    component: EditarElemento,
  },
  {
    path: "/dotacoes/visualizar/:id",
    name: "Index",
    component: Index,
  },
  {
    path: "/repasses/visualizar/:id",
    name: "IndexRepasse",
    component: IndexRepasse,
  },
  {
    path: "/elementos-itens/editar/:id",
    name: "EditarElementoItem",
    component: EditarElementoItem,
  },
  {
    path: "/exercicios/editar/:id",
    name: "EditarExercicio",
    component: EditarExercicio,
  },
  {
    path: "/fontes/editar/:id",
    name: "EditarFonte",
    component: EditarFonte,
  },
  {
    path: "/grupos/editar/:id",
    name: "EditarGrupo",
    component: EditarGrupo,
  },
  {
    path: "/ipg/editar/:id",
    name: "EditarIpg",
    component: EditarIpg,
  },
  {
    path: "/ipu/editar/:id",
    name: "EditarIpu",
    component: EditarIpu,
  },
  {
    path: "/ppag/editar/:id",
    name: "EditarPpag",
    component: EditarPpag,
  },
  {
    path: "/programa/editar/:id",
    name: "EditarPrograma",
    component: EditarPrograma,
  },
  {
    path: "/secoes/editar/:id",
    name: "EditarSecao",
    component: EditarSecao,
  },
  {
    path: "/unidades-executoras/editar/:id",
    name: "EditarUnidadeExecutora",
    component: EditarUnidadeExecutora,
  },
  {
    path: "/unidades-orcamentarias/editar/:id",
    name: "EditarUnidadeOrcamentaria",
    component: EditarUnidadeOrcamentaria,
  },
  {
    path: "/logs/configuracao",
    name: "IndexConfiguracao",
    component: IndexConfiguracao,
  },
  {
    path: "/logs/gerenciar",
    name: "GerenciarLogs",
    component: GerenciarLogs,
  },
  {
    path: "/logs/visualizar/:id",
    name: "VisualizarLog",
    component: VisualizarLog,
  },
  {
    path: "/importar-unidades-primarias",
    name: "ImportarUnidadesPrimarias",
    component: ImportarUnidadesPrimarias,
  },
  {
    path: "/unidades-primarias/editar/:id",
    name: "EditarUnidadePrimaria",
    component: EditarUnidadePrimaria,
  },
  {
    path: "/gerenciar-unidades-primarias",
    name: "GerenciarUnidadesPrimarias",
    component: GerenciarUnidadesPrimarias,
  },
  {
    path: "/montar-plano-aquisicao",
    name: "Montar",
    component: Montar,
  },
  {
    path: "/montar-plano-aquisicao/:id",
    name: "MontarComId",
    component: Montar,
  },
  {
    path: "/importar-processos-compra",
    name: "ImportarProcessosCompra",
    component: ImportarProcessosCompra,
  },
  {
    path: '/ipgs/editar/:id',
    name: 'EditarIpg',
    component: () => import('../views/ipg/editar/EditarIpg.vue')
  },
  {
    path: "/gerenciar-emendas-estaduais",
    name: "GerenciarEmendasEstaduais",
    component: GerenciarEmendasEstaduais,
  },
  {
    path: "/gerenciar-emendas-federais",
    name: "GerenciarEmendasFederais",
    component: GerenciarEmendasFederais,
  },
  {
    path: "/gerenciar-convenios-federais",
    name: "GerenciarConveniosFederais",
    component: GerenciarConveniosFederais,
  },
  {
    path: "/gerenciar-elementos-primarios-genericos",
    name: "GerenciarElementosPrimariosGenericos",
    component: GerenciarElementosPrimariosGenericos,
  },
  {
    path: "/gerenciar-elementos-primarios-consolidados",
    name: "GerenciarElementosPrimariosConsolidados",
    component: GerenciarElementosPrimariosConsolidados,
  },
  {
    path: "/elementos-primarios-consolidados/visualizar/:tipo/:id",
    name: "VisualizarElementoPrimarioConsolidado",
    component: VisualizarElementoPrimarioConsolidado,
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router